import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab }                      from "semantic-ui-react";
import Account                      from "../../../domain/account/Account";
import { ResKaState }               from "../../../index";
import RouterDispatcher             from "../../../infrastructure/redux/router/RouterDispatcher";
import CustomerEdit                 from "./CustomerEdit";

const CustomerEditTab: FC = () => {
  const account: Account = useSelector((state: ResKaState) => state.account);
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  if (!account.options.hasRecord()) {
    return (
      <>
        <Tab
          renderActiveOnly
          activeIndex={ 0 }
          panes={ [
            {
              menuItem: "基本情報",
              render: () => (
                <Tab.Pane>
                  <CustomerEdit/>
                </Tab.Pane>
              )
            },
          ] }
        />
      </>
    );
  }

  return (
    <>
      <Tab
        renderActiveOnly
        activeIndex={ 0 }
        onTabChange={ (event, data) => {
          if (data.activeIndex === 1) routerDispatcher.customerRecords();
        } }
        panes={ [
          {
            menuItem: "基本情報",
            render: () => (
              <Tab.Pane>
                <CustomerEdit/>
              </Tab.Pane>
            )
          },
          {
            menuItem: "記録情報",
          }
        ] }
      />
    </>
  );
};

export default CustomerEditTab;
